import ConnectedStatusIndicator from './component'

export default ConnectedStatusIndicator